// @vue/component
import holidayElementMap from './holidayElementMap';
import typeHolidayMap from './typeHolidayMap';

export default {
  name: 'CurrentHolidayListPopover',

  components: {
    holidayElementMap,
    typeHolidayMap,
  },


  props: {
    holidayList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isTooltipVisible: false,
    };
  },
  created() {
    setTimeout(() => {
      this.isTooltipVisible = true;
    }, 5000);
  },
  methods: {
    getTextForElement(element) {
      return holidayElementMap[element].text;
    },
    getTextForType(element) {
      return typeHolidayMap[element].text;
    },
  },
};
